var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawer"},[_c('a-drawer',{attrs:{"wrapClassName":_vm.name,"width":"500","placement":"right","closable":false,"visible":_vm.visible},on:{"close":_vm.onClose}},[_vm._t("header"),_vm._t("default"),_vm._t("footer")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }